<script setup lang="ts">
    /**
     * this is a wrapper around vuetify `VTextField`.
     *
     * @see https://vuetifyjs.com/en/api/v-text-field/ for list of available props
     */
    export interface VTextFieldProps {
        modelValue?: string | number;
        disabled?: boolean;
        prependInnerIcon?: string;
        appendInnerIcon?: string;
        clearIcon?: string;
        onAppendInner?: () => void;
        onPrependInner?: () => void;
        onClear?: () => void;
        hideDetails?: boolean;
        clearable?: boolean;
        placeholder?: string;
        bgColor?: string;
        type?: string;
        suffix?: string;
        variant?:
            | 'outlined'
            | 'filled'
            | 'plain'
            | 'underlined'
            | 'solo'
            | 'solo-inverted'
            | 'solo-filled';
         
        rules?: Array<(value: any) => boolean | string>;
        ariaLabel?: string;
        hint?: string;
        errorMessages?: string;
        dataTestId?: string;
        inputId?: string;
        maxLength?: string;
        width?: string;
        cyData?: string;
        class?: string;
    }

    withDefaults(defineProps<VTextFieldProps>(), {
        variant: 'outlined',
        maxLength: '255',
        width: '100%',
    });
</script>

<template>
    <v-hover class="w-100">
        <template #default="{ isHovering, props }">
            <v-text-field
                v-bind="{ ...$attrs, ...props }"
                :id="inputId"
                :cy-data="cyData"
                :width="width"
                :disabled="disabled"
                class="custom-text-field d-inline-block"
                color="secondary-text"
                :base-color="isHovering ? 'secondary-text' : 'grey-light-1'"
                :model-value="modelValue"
                density="compact"
                :variant="variant"
                :persistent-clear="true"
                :single-line="true"
                :prepend-inner-icon="prependInnerIcon"
                :clear-icon="clearIcon"
                :append-inner-icon="appendInnerIcon"
                :hide-details="hideDetails"
                :bg-color="bgColor"
                :placeholder="placeholder"
                :clearable="clearable"
                :type="type"
                :suffix="suffix"
                :rules="rules"
                :aria-label="ariaLabel"
                :hint="hint"
                :error-messages="errorMessages"
                :data-testid="dataTestId"
                :maxlength="maxLength"
                :class="props.class"
                @update:model-value="$emit('update:modelValue', $event)"
                @click:append-inner="onAppendInner"
                @click:prepend-inner="onPrependInner"
                @click:clear="$emit('update:modelValue', '')"
            />
        </template>
    </v-hover>
</template>

<style scoped lang="scss">
    :deep(.v-text-field__suffix) {
        opacity: 1 !important;
    }

    .custom-text-field :deep(.v-field) {
        border-radius: 4px !important;
    }

    //.custom-text-field :deep(.v-field__outline) {
    //    &:hover {
    //        border: 2px solid rgb(var(--v-theme-primary)) !important;
    //    }
    //}

    //
    //    &:not(:hover) {
    //        border: rgb(var(--v-theme-grey-light-1)) !important;
    //    }
    //}

    .custom-text-field :deep(input) {
        border-top-left-radius: 4px !important;
        border-bottom-left-radius: 4px !important;
    }

    :deep(input) {
        color: rgb(var(--v-theme-secondary-text)) !important;
        display: block;

        &::placeholder {
            color: rgb(var(--v-theme-secondary)) !important;
        }
    }

    :deep(input[type="date"]::-webkit-calendar-picker-indicator) {
        background: url(../../assets/icons/calendar.svg) no-repeat;
        background-size: 21px 21px;
        color: #152130;
    }
</style>
